import { FC, memo } from 'react';
import type { FallbackProps } from 'react-error-boundary';
import { ErrorBoundary, useErrorBoundary } from 'react-error-boundary';
import ErrorAlert from '../../components/UI/ErrorAlert';
import Loader from '../../components/UI/Loader';
import { useLoader } from '../../contexts/LoaderContext';
import AppRoutes from '../../routes';

/**
 * App Props Interface
 * @interface AppProps
 */
interface AppProps {}

const App: FC<AppProps> = () => {
  const { loading } = useLoader();


  // component for error boundary
  const ErrorFallback = ({ error }: FallbackProps) => {
    const { resetBoundary } = useErrorBoundary();

    return (
      <ErrorAlert
        message={error.message}
        onClose={resetBoundary}
      />
    );
  }

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      {loading && <Loader message="Loading..." />}
      <AppRoutes />
    </ErrorBoundary>
  )
}
export default memo(App)
